const data = {
  id: "environment",
  title: "Environment",
  intro: "They'll never put it in a press release — but rolling back environmental protections, permitting industrial facilities near homes, and contaminating groundwater all have one thing in common: the people it happens to are rarely the people who made the decision. What's in the air, the water, and the soil in Huntsville — documented.",
  tabs: [
    {
      id: "overview",
      label: "Overview",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "contamination",
      label: "Contamination & Superfund",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "air_water_quality",
      label: "Air & Water Quality",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "industrial_zoning",
      label: "Industrial Zoning",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};
export default data;
